import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useEffect, useState } from 'react'

import useHomepage from '../../hooks/useHomepage'
import ScrollAnimation from '../scroll-animation/Container'

type Props = {
  isSectionInView: boolean
}

const Title: React.FC<Props> = ({ isSectionInView }) => {
  const { t } = useTranslation()
  const { animationProps } = useHomepage()
  const [animation, setAnimation] = useState<string>('')

  useEffect(() => {
    const animationSource = isSectionInView ? `/underline-transparent.gif?a=${Math.random()}` : ''
    setAnimation(animationSource)
  }, [isSectionInView])

  return (
    <div className="meals__title">
      <ScrollAnimation {...animationProps}>
        {t('MealPal Exclusive:')} <br />
        <span className="meals__animation">
          {t('40% OFF')}
          {animation && (
            <div className="meals__animation-image">
              <img src={animation} />
            </div>
          )}
        </span>
        {t('restaurant prices')}
      </ScrollAnimation>
    </div>
  )
}

export default Title
